import { CaretDownOutlined } from '@ant-design/icons';
import { BackTop, Col, Collapse, Grid, Layout, Modal, Row } from 'antd';
import "antd/dist/antd.css";
import { BigNumber } from 'ethers';
import React, { useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';
import "./App.css";
import AppHeader from './components/AppHeader';
import LoadingMask from './components/LoadingMask';
import {
  AddButton, BannerContainer,
  BannerGif, ConentOrderList, Container, CountdownText, Desc, FaqTitle, FirmTitle, Footer, H2,
  H3, ImgBlock, Logo, MemberAvatar, MintBtn,
  MintDecoration, MinusButton, PhaseTitle, RoadmapImg, RoadmapTitle, SocialContainer, TeamTitle
} from './components/styled/home/StyledComponents';
import { DISCORD_LINK, INSTAGRAM_LINK, TWITTER_LINK } from './constants';
import { openNotificationWithIcon } from './helpers/notification';
import { useSandzNFTContract } from './hooks/useContract';
import { useActiveWeb3React } from './hooks/web3';
import bannerGif from './images/banner.gif';
import footerLogo from './images/footer-logo.png';
import backTopIcon from './images/icon/back-top.png';
import discordIcon from './images/icon/discord-icon-lg.png';
import igIcon from './images/icon/ig-icon-lg.png';
import twIcon from './images/icon/twitter-icon-lg.png';
import memberAM from './images/member/AM.jpg';
import memberDavid from './images/member/David.jpg';
import memberHedy from './images/member/Hedy.jpg';
import memberOaken from './images/member/oaken.jpg';
import memberCevil from './images/member/Cevil.jpg';
import memberFreddy from './images/member/Freddy.jpg';
import memberKevin from './images/member/Kevin.jpg';
import memberLori from './images/member/Lori.jpg';
import memberSfc from './images/member/Sfc.jpg';
import memberZ_s from './images/member/Z_s.jpg';
import memberKairosLab from './images/member/Kairos_lab.png';
import memberJack from './images/member/Jack.jpeg';

import mintGif from './images/mint-card.gif';
import './style/backtotop.css';
import "./style/collapse.css";
import './style/mint-modal.css';
import "./style/tooltip.css";
import VOUCHER_MAP_HARDHAT from './whitelist/whitelist_hardhat.json';
// import VOUCHER_MAP_MAINNET from './whitelist/whitelist_mainnet.json';
import VOUCHER_MAP_RINKEBY from './whitelist/whitelist_rinkeby.json';
import { MINT_PRICE } from './constants';



const { useBreakpoint } = Grid;
const { Panel } = Collapse;


type Voucher = {
  voucher: {
    redeemer: string;
    stageId: number;
    nonce: number;
    amount: number;
    price: string;
  };
  signature: string;
}
type StageInfo = {
  isPublic: boolean;
  stageId: number;
  maxSupply: number;
  startTime: number;
  endTime: number;
  publicPrice: BigNumber;
}
export enum SupportedChainId {
  MAINNET = 1,
  RINKEBY = 4,
  HARDHAT = 1337,
}

const voucherMapHardhat = new Map(Object.entries(VOUCHER_MAP_HARDHAT));
const voucherMapRinkeby = new Map(Object.entries(VOUCHER_MAP_RINKEBY));
// const voucherMapMainnet = new Map(Object.entries(VOUCHER_MAP_MAINNET));

const voucherMap: { [key in SupportedChainId]: Map<string, Voucher> } = {
  [SupportedChainId.MAINNET]: voucherMapHardhat,
  [SupportedChainId.RINKEBY]: voucherMapRinkeby,
  [SupportedChainId.HARDHAT]: voucherMapHardhat,
}
interface Firm {
  img: string,
  imgWidth: number[],
  title: string,
  subtitle: string,
  description?: string,
}

const firmList: Firm[] = [
  {
    img: require('./images/firm/firm9.png').default,
    imgWidth: [16, 37],
    title: 'MADE taipei',
    subtitle: '台北市大安區忠孝東路四段94號2F',
  },
  {
    img: require('./images/firm/firm2.png').default,
    imgWidth: [47, 108],
    title: 'Akira',
    subtitle: '359 Mill St, Eugene,<br />OR 97401 美國(奧勒岡州）',
  },
  {
    img: require('./images/firm/firm3.png').default,
    imgWidth: [32, 73],
    title: 'Tomo sushi',
    subtitle: '623 SW 152nd St, Burien,<br />WA 98166  美國（西雅圖）',
  },
  {
    img: require('./images/firm/firm4.png').default,
    imgWidth: [32, 61],
    title: '牡丹',
    subtitle: '台北市大安區四維路52巷17號',
  },
  {
    img: require('./images/firm/firm5.png').default,
    imgWidth: [63, 141],
    title: '十八居居酒屋',
    subtitle: '台北市大安區忠孝東路四段248巷17號',
  },
  {
    img: require('./images/firm/firm6.png').default,
    imgWidth: [34, 75],
    title: '老司機居酒屋',
    subtitle: '台北市南港區南港路一段257號',
  },
  {
    img: require('./images/firm/firm7.png').default,
    imgWidth: [59, 132],
    title: '魔藥學餐酒館',
    subtitle: '台北市大安區安和路1段55-1號',
  },
  {
    img: require('./images/firm/firm8.png').default,
    imgWidth: [54, 123],
    title: '阿里巴巴的印度廚房',
    subtitle: '台北市中山區南京東路二段56號2F',
  },
  {
    img: require('./images/firm/firm10.png').default,
    imgWidth: [50, 122],
    title: 'Craftsman and Wolves',
    subtitle: '746 Valencia St,<br />San Francisco, CA 94110',
  },
  {
    img: require('./images/firm/firm11.png').default,
    imgWidth: [34, 65],
    title: 'PLUS Fitness Studio',
    subtitle: '台北市中山區復興北路446號',
  },
]



interface Faq {
  title: string,
  content: string,
}

interface Member {
  img: string,
  name: string,
  position: string,
  content: string,
}


const App = () => {
  const { md: isDesktop } = useBreakpoint();
  const [mintButtonDisabled, setMintButtonDisabled] = useState(false)
  const [mintAmount, setMintAmount] = useState('1');
  const [activeCardIndex, setActiveCardIndex] = useState(4);
  const [isModalVisible, setModalVisible] = useState(false);
  const [stageInfo, setStageInfo] = useState<StageInfo>()
  const [availableMint, setAvailableMint] = useState(0);
  const { account, chainId } = useActiveWeb3React();
  // const [totalSupply, setTotalSupply] = useState(0);
  const sandzNFT = useSandzNFTContract();
  const { t, i18n } = useTranslation();

  const faqList: Faq[] = [
    { title: t('faq_title_1'), content: t('faq_answer_1') },
    { title: t('faq_title_2'), content: t('faq_answer_2') },
    { title: t('faq_title_3'), content: t('faq_answer_3') },
    { title: t('faq_title_4'), content: t('faq_answer_4') },
    { title: t('faq_title_5'), content: t('faq_answer_5') }
  ]

  const memberList: Member[] = [
    { img: memberCevil, name: 'Cevil', position: t('member_6_position'), content: t('member_6_content') },
    { img: memberFreddy, name: 'Freddy', position: t('member_5_position'), content: t('member_5_content') },
    { img: memberSfc, name: 'ScfPeter', position: t('member_9_position'), content: t('member_9_content') },
    { img: memberZ_s, name: 'Z’s', position: t('member_10_position'), content: t('member_10_content') },
    { img: memberDavid, name: 'David', position: t('member_1_position'), content: t('member_1_content') },
    { img: memberKevin, name: 'Kevin', position: t('member_7_position'), content: t('member_7_content') },
    { img: memberAM, name: 'AM', position: t('member_2_position'), content: t('member_2_content') },
    { img: memberLori, name: 'Lori', position: t('member_8_position'), content: t('member_8_content') },
    { img: memberOaken, name: 'Oaken', position: t('member_4_position'), content: t('member_4_content') },
    { img: memberHedy, name: 'Hedy', position: t('member_3_position'), content: t('member_3_content') },
    { img: memberJack, name: 'Jack', position: t('member_11_position'), content: t('member_11_content') },
    { img: memberKairosLab, name: 'KairosLab', position: '', content: '' },
  ]

  useEffect(() => {
    if (!chainId || !account) return;
    if (chainId !== 1 && chainId !== 1337 && chainId !== 4) {
      openNotificationWithIcon('info', 'Please connect to Ethereum Mainnet', 'Switch your network to Ethereum Mainnet')
      return;
    }
    const getStageInfto = async () => {
      if (!sandzNFT) return;
      setStageInfo((await sandzNFT?.stageInfo()))
      setAvailableMint((await sandzNFT?.whitelistInfo(account)).remain.toNumber())
      // setTotalSupply((await sandzNFT.totalSupply()).toNumber())

    }
    getStageInfto()
  }, [chainId, sandzNFT, account])

  useEffect(() => {
    const timer = setInterval(() => {
      const randomIndex = randomNumber(0, 8)
      setActiveCardIndex(randomIndex)
    }, 2000)

    return () => clearInterval(timer)
  }, [])
  const handleMint = async () => {
    if (!account) {
      openNotificationWithIcon('info', 'Please connect to Wallet', "")
      return;
    }
    if (chainId !== 1 && chainId !== 1337 && chainId !== 4) {
      openNotificationWithIcon('info', 'Please connect to Ethereum Mainnet', 'Switch your network to Ethereum Mainnet')
      return;
    }
    if (!mintAmount) return;

    if (stageInfo?.stageId === 1) {

      const data = voucherMap[chainId].get(account)
      if (!data) {
        openNotificationWithIcon('info', 'Not in whitelist', '')
        return
      }
      if (stageInfo.startTime * 1000 > Date.now()) {
        openNotificationWithIcon('info', "Sales has'nt started yet", '')
        return
      }
      const voucher = data?.voucher
      const signature = data?.signature

      try {
        setMintButtonDisabled(true)
        const tx = await sandzNFT?.whitelistMint(voucher, signature, mintAmount, {
          value: BigNumber.from(voucher.price).mul(mintAmount)
        })
        const receipt = await tx?.wait()
        if (receipt?.status) {
          openNotificationWithIcon('success', 'Mint success!', "Welcome to the Sandz NFT! You can now check on Opensea.")
          setMintAmount('1')
        }
      } catch (err) {
        setMintButtonDisabled(false)
        // @ts-ignore:next-line
        if (err.code === "INSUFFICIENT_FUNDS") {
          openNotificationWithIcon('error', 'INSUFFICIENT FUND', "You might not have enough fund to perform this opertaion")
          return
        }
        // @ts-ignore:next-line
        if (err.code === 4001) {
          openNotificationWithIcon('error', 'User denied transaction signature', "")
          return
        }
        openNotificationWithIcon('error', 'Error while sending transaction', "")
      }
    } else {
      try {
        setMintButtonDisabled(true)
        const tx = await sandzNFT?.publicMint(mintAmount, {
          value: stageInfo?.publicPrice?.mul(mintAmount)
        })
        const receipt = await tx?.wait()
        if (receipt?.status) {
          openNotificationWithIcon('success', 'Mint success!', "Welcome to the Sandz NFT! You can now check on Opensea.")
          setMintAmount('1')
        }
      } catch (err) {
        setMintButtonDisabled(false)
        // @ts-ignore:next-line
        console.log(err)
        // @ts-ignore:next-line
        if (err.code === "INSUFFICIENT_FUNDS") {
          openNotificationWithIcon('error', 'INSUFFICIENT FUND', "You might not have enough fund to perform this opertaion")
          return
        }
        // @ts-ignore:next-line
        if (err.code === 4001) {
          openNotificationWithIcon('error', 'User denied transaction signature', "")
          return
        }
        // @ts-ignore:next-line
        openNotificationWithIcon('error', 'Error while sending transaction', err)
      }
    }

    setMintButtonDisabled(false)
  }

  const minusMintCount = () => {
    if (mintAmount === '1') return;
    setMintAmount((parseInt(mintAmount) - 1).toString())
  }

  const addMintCount = () => {
    if (Number(mintAmount) >= 5) return;
    setMintAmount((parseInt(mintAmount) + 1).toString())
  }

  const randomNumber = (min: number, max: number) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }


  return (
    <Layout style={{ backgroundColor: 'black' }}>
      <LoadingMask />
      <AppHeader />
      {/* 首屏 */}
      <BannerContainer>
        <BannerGif src={bannerGif} />
        <CountdownText>
          <Countdown daysInHours={true} date={Date.now() + 100000000} />
        </CountdownText>
        <MintBtn onClick={() => setModalVisible(true)}> MINT </MintBtn>
        <MintDecoration>
          Scroll
        </MintDecoration>
      </BannerContainer>
      {/* 介紹 */}
      <Container style={{ padding: isDesktop ? '150px 170px 100px' : '86px 30px 28px' }}>
        <H2 id="about">ABOUT</H2>
        <H3 isEn={i18n.language === 'en'}>
          {t('about_title_1').length > 0 ?
            <>
              <span style={{ fontFamily: isDesktop ? 'KozGoPr6N-ExtraLight' : 'KozGoPr6N-Heavy' }}>
                {t('about_title_1')}
              </span>
              <br />
              {t('about_title_2')}
            </>
            : t('about_title_2')
          }
        </H3>
        <Desc isEn={i18n.language === 'en'}>
          {t('about_desc_1')}
        </Desc>

        <Desc isEn={i18n.language === 'en'}>
          {t('about_desc_2')}
        </Desc>

        <Desc isEn={i18n.language === 'en'}>
          {t('about_desc_3')}
        </Desc>
      </Container>
      {/* Roadmap */}
      <Container id='roadmap' style={{ padding: isDesktop ? '100px 180px 0' : '28px 20px 0' }}>
        <Row gutter={[0, { xs: 40, md: 0 }]}>
          <Col span={24} md={12}>
            <div style={{ marginLeft: isDesktop ? '-60px' : '0' }}>
              <ImgBlock>
                {
                  Array.from(Array(9).keys())
                    .map(i =>
                      <RoadmapImg
                        isNotGray={i === activeCardIndex}
                        src={require(`./images/member/roadmap${i + 1}.png`).default}
                        alt={`member${i}`}
                        key={`member${i}`}
                      />
                    )
                }
              </ImgBlock>
            </div>
          </Col>
          <Col span={24} md={12}>
            <div style={{ color: '#fff' }}>
              <RoadmapTitle>ROAD MAP</RoadmapTitle>
              <div>
                <PhaseTitle>Phase 1</PhaseTitle>
                <ConentOrderList isEn={i18n.language === 'en'}>
                  <li>{t('phase_1_text_1')}</li>
                  <li>{t('phase_1_text_2')}</li>
                  <li>{t('phase_1_text_3')}</li>
                  <li><span style={{ fontFamily: 'KozGoPr6N-Bold' }}>{t('phase_1_text_4_title')}</span>{t('phase_1_text_4')}</li>
                  <li><span style={{ fontFamily: 'KozGoPr6N-Bold' }}>{t('phase_1_text_5_title')}</span> {t('phase_1_text_5')}</li>
                </ConentOrderList>
              </div>
            </div>
          </Col>
          <Col span={24} md={24}>
            <div style={{ color: '#fff' }}>
              <div style={{ position: 'relative', padding: isDesktop ? '81px 5px 70px' : '' }}>
                <PhaseTitle>Phase 2</PhaseTitle>
                <ConentOrderList isEn={i18n.language === 'en'}>
                  <li><span style={{ fontFamily: 'KozGoPr6N-Bold' }}>{t('phase_2_text_1_title')}</span>{t('phase_2_text_1')}</li>
                  <li><span style={{ fontFamily: 'KozGoPr6N-Bold' }}>{t('phase_2_text_2_title')}</span>{t('phase_2_text_2')}</li>
                  <li><span style={{ fontFamily: 'KozGoPr6N-Bold' }}>{t('phase_2_text_3_title')}</span>{t('phase_2_text_3')}</li>
                  <li><span style={{ fontFamily: 'KozGoPr6N-Bold' }}>{t('phase_2_text_4_title')}</span>{t('phase_2_text_4')}</li>
                </ConentOrderList>
              </div>
            </div>
          </Col>
          <Col span={24} md={18} offset={isDesktop ? 8 : 0}>
            <div style={{ color: '#fff' }}>
              <div style={{ position: 'relative', padding: isDesktop ? '81px 5px 70px' : '' }}>
                <PhaseTitle>Phase 3</PhaseTitle>
                <ConentOrderList isEn={i18n.language === 'en'}>
                  <li><span style={{ fontFamily: 'KozGoPr6N-Bold' }}>{t('phase_3_text_1_title')}</span>{t('phase_3_text_1')}</li>
                  <li>{t('phase_3_text_2')}</li>
                  <li><span style={{ fontFamily: 'KozGoPr6N-Bold' }}>{t('phase_3_text_3_title')}</span>{t('phase_3_text_3')}</li>
                  <li>{t('phase_3_text_4')}</li>
                </ConentOrderList>
              </div>
            </div>
          </Col>
          <Col span={24} md={24} offset={isDesktop ? 2 : 0}>
            <div style={{ color: '#fff' }}>
              <div style={{ position: 'relative', padding: isDesktop ? '81px 5px' : '' }}>
                <PhaseTitle>Phase 4</PhaseTitle>
                <ConentOrderList isEn={i18n.language === 'en'}>
                  <li><span style={{ fontFamily: 'KozGoPr6N-Bold' }}>{t('phase_4_text_1_title')}</span> {t('phase_4_text_1')}</li>
                  <li><span style={{ fontFamily: 'KozGoPr6N-Bold' }}>{t('phase_4_text_2_title')}</span> {t('phase_4_text_2')}</li>
                  <li>{t('phase_4_text_3')}</li>
                </ConentOrderList>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      {/* 團隊介紹 */}
      <TeamTitle id='team'>
        <h2 style={{ color: '#000', margin: 'auto', fontSize: isDesktop ? '48px' : '16px' }}>TEAM INTRODUCTION</h2>
      </TeamTitle>
      <div style={{ marginTop: isDesktop ? '110px' : '55px', marginBottom: isDesktop ? '140px' : '55px', display: 'flex', flexWrap: 'nowrap', overflowX: 'auto' }}>
        {
          memberList.map((member, index) => (
            <div style={{ color: '#fff', width: 'calc(100vw / 4)', maxWidth: '350px', flexShrink: 0 }} key={member.name}>
              <MemberAvatar data-tip data-for={`member-${index}`} src={member.img} alt="" />
              <ReactTooltip id={`member-${index}`} className='custom-tooltip'>
                <div style={{ fontFamily: 'KozGoPr6N-Regular', textAlign: 'center', color: 'rgba(149, 149, 149)', fontSize: '18px', marginBottom: '15px' }}>{member.position}</div>
                <div style={{ fontFamily: 'KozGoPr6N-Heavy', textAlign: 'center', fontSize: '23px', marginBottom: '20px' }}>{member.name}</div>
                <div style={{ fontFamily: 'KozGoPr6N-Bold', fontSize: '16px', lineHeight: '27px', letterSpacing: '0.56px', whiteSpace: 'pre-wrap' }}>
                  {member.content}
                </div>
              </ReactTooltip>
            </div>
          ))
        }
      </div>
      {/* FAQ */}
      <FaqTitle id='faq'>
        <h2 style={{ color: '#000', margin: 'auto', fontSize: isDesktop ? '48px' : '16px' }}>FAQ</h2>
      </FaqTitle>
      <Container style={{ maxWidth: isDesktop ? '978px' : 'calc(100% - 60px)', marginBottom: isDesktop ? '130px' : '65px' }}>
        <Collapse
          expandIconPosition='right'
          bordered={false}
          expandIcon={({ isActive }) => <CaretDownOutlined style={{ fontSize: '22px' }} rotate={isActive ? 180 : 0} />}
        >
          {
            faqList
              .map((faq, index) =>
                <Panel header={faq.title} key={index} className='collapse-custom-panel'>
                  {faq.content}
                </Panel>
              )
          }
        </Collapse>
      </Container>
      {/* 公司logo */}
      <FirmTitle id='firm'>
        <h2 style={{ color: '#000', margin: 'auto', fontSize: isDesktop ? '48px' : '16px' }}>FIRM</h2>
      </FirmTitle>
      <Container>
        <Row style={{ maxWidth: isDesktop ? '1033px' : '100%', margin: '0 auto', padding: isDesktop ? '0' : '0 14px', fontFamily: 'KozGoPr6N-Medium' }}>
          {
            firmList.map((firm, index) =>
              <Col span={8} md={6} key={index}>
                <div style={{ padding: isDesktop ? '60px 0' : '20px 0', textAlign: 'center', color: 'rgba(153, 153, 153)', borderBottom: isDesktop && index < 8 ? 'solid 1px #fff' : !isDesktop && index < 6 ? 'solid 2px #fff' : undefined }}>
                  <div style={{ height: isDesktop ? '91px' : '41px', display: 'flex', marginBottom: isDesktop ? '36px' : '16px' }}>
                    <img style={{ width: isDesktop ? `${firm.imgWidth[1]}px` : `${firm.imgWidth[0]}px`, margin: 'auto' }} src={firm.img} alt="" />
                  </div>
                  <div style={{ fontSize: isDesktop ? '16px' : '13px', lineHeight: 1.5, height: isDesktop ? 'auto' : '40px', letterSpacing: '1.12px', marginBottom: isDesktop ? '24px' : '4px' }}>{firm.title}</div>
                  <div dangerouslySetInnerHTML={{ __html: firm.subtitle }} style={{ fontSize: isDesktop ? '12px' : '10px', height: isDesktop ? '28px' : '64px', lineHeight: '16px', marginBottom: '10px' }} />
                </div>
              </Col>
            )
          }
        </Row>
      </Container>
      <SocialContainer>
        <div style={{ marginRight: isDesktop ? '70px' : '20px' }}>
          <div style={{ color: '#fff', fontSize: isDesktop ? '60px' : '16px', lineHeight: isDesktop ? '74px' : '20px', fontFamily: 'KozGoPr6N-Bold' }}>JOIN THE<br />SANDZ CLUB</div>
          <div style={{ display: 'flex', paddingTop: isDesktop ? '20px' : '4px' }}>
            <a href={INSTAGRAM_LINK} target="_blank" rel="noreferrer">
              <img src={igIcon} alt="instagram" style={{ width: isDesktop ? '64px' : '18px' }} />
            </a>
            <a href={DISCORD_LINK} target="_blank" style={{ margin: isDesktop ? '0 35px' : '0 8px' }} rel="noreferrer">
              <img src={discordIcon} alt="discord" style={{ width: isDesktop ? '70px' : '18px' }} />
            </a>
            <a href={TWITTER_LINK} target="_blank" rel="noreferrer">
              <img src={twIcon} alt="twitter" style={{ width: isDesktop ? '64px' : '18px' }} />
            </a>
          </div>
        </div>
        <Logo src={footerLogo} alt="logo" style={{ marginLeft: isDesktop ? '70px' : '20px', flexShrink: '0' }} />
      </SocialContainer>
      <div style={{ background: '#fff' }}>
        <Footer>
          <div>
            Copyright © 2022 SANDZ CLUB.&nbsp;&nbsp;All rights reserved.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
          <div>
            TERMS &  CODITIONS
          </div>
        </Footer>
      </div>
      {/* Mint Modal */}
      <Modal
        visible={isModalVisible}
        footer={null}
        wrapClassName='mint-modal'
        onCancel={() => setModalVisible(false)}
      >
        <div className='mint-container'>
          <div className='mint-card'>
            <div className='mint-card__title'>OG Whitelist</div>
            <img className='mint-card__img' src={mintGif} alt="" />
            <div className='mint-card__desc'>Mint Price</div>
            <div className='mint-card__price'>{parseFloat((MINT_PRICE * Number(mintAmount)).toFixed(10))} ETH</div>
          </div>
          <div className='mint-action'>
            <div className='mint-action__title'>Mint Amount</div>
            <div className='mint-action__input'>
              <MinusButton onClick={minusMintCount} />
              <span>{mintAmount}</span>
              <AddButton onClick={addMintCount} />
            </div>
            <button className='mint-action__btn' onClick={handleMint} disabled={mintButtonDisabled}>Mint Now</button>
            <div className='mint-action__count'>Available Mint: {availableMint}</div>
          </div>
        </div>
      </Modal>
      <BackTop visibilityHeight={isDesktop ? 2700 : 2460} duration={100}>
        {isDesktop ? <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#fff', height: '100%', background: '#000', fontFamily: 'KozGoPr6N-Heavy', paddingTop: '14px' }}>
          <img src={backTopIcon} alt="backtop" width="45" />
          <div style={{ display: isDesktop ? 'block' : 'none', fontSize: '40px', marginTop: '5px', letterSpacing: '2px', lineHeight: '34px' }}>Top</div>
        </div> : <img src={backTopIcon} alt="backtop" width="40" />}

      </BackTop>
    </Layout>
  );
}

export default App;
